export default __webpack_public_path__ + "static/media/checkmark_image.331077dc.png";